import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

// ── Loop comms ──────────────────────────────────────────────────────────────

// GET /loop/comms/<level>/<level_id>
// Returns grouped response: { categories, no_category, total_templates }
const getCategorizedTemplates = (level, levelId) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/comms/${level}/${levelId}`,
    method: 'get',
  });

// PUT /loop/comms/<level>/<level_id>
// payload: { email_templates: [{ event, template_id, enabled }] }
const updateTemplate = (level, levelId, payload) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/comms/${level}/${levelId}`,
    method: 'put',
    data: payload,
  });

// PUT /loop/comms/categories/<category_id>/templates
// payload: { level, level_id, enabled }
const toggleCategoryStatus = (categoryId, payload) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/comms/categories/${categoryId}/templates`,
    method: 'put',
    data: payload,
  });

// PUT /loop/comms/templates
// payload: { level, level_id, enabled, template_ids: [event_name, ...] }
const toggleNoCategoryStatus = (payload) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/comms/templates`,
    method: 'put',
    data: payload,
  });

// ── Sync notification templates ─────────────────────────────────────────────

// GET /sync/notification/templates/<level>/<level_id>
// Returns same grouped response: { categories, no_category, total_templates }
const getSyncCategorizedTemplates = (level, levelId) =>
  httpService({
    url: `${getApiBaseUrl()}/sync/notification/templates/${level}/${levelId}`,
    method: 'get',
  });

// PUT /sync/notification/templates/<level>/<level_id>
// payload: { email_templates: [{ event, template_id, enabled }] }
const updateSyncTemplate = (level, levelId, payload) =>
  httpService({
    url: `${getApiBaseUrl()}/sync/notification/templates/${level}/${levelId}`,
    method: 'put',
    data: payload,
  });

// PUT /sync/notification/categories/<category_id>/templates
// payload: { level, level_id, enabled }
const toggleSyncCategoryStatus = (categoryId, payload) =>
  httpService({
    url: `${getApiBaseUrl()}/sync/notification/categories/${categoryId}/templates`,
    method: 'put',
    data: payload,
  });

// PUT /sync/notification/templates
// payload: { level, level_id, enabled, template_ids: [event_name, ...] }
const toggleSyncNoCategoryStatus = (payload) =>
  httpService({
    url: `${getApiBaseUrl()}/sync/notification/templates`,
    method: 'put',
    data: payload,
  });

const EMAIL_TEMPLATE_CATEGORY_SERVICES = {
  getCategorizedTemplates,
  updateTemplate,
  toggleCategoryStatus,
  toggleNoCategoryStatus,
  getSyncCategorizedTemplates,
  updateSyncTemplate,
  toggleSyncCategoryStatus,
  toggleSyncNoCategoryStatus,
};

export default EMAIL_TEMPLATE_CATEGORY_SERVICES;
